import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProjectOverview from './components/ProjectOverview';
import LandParcelAnalysis from './components/LandParcelAnalysis';
import DesignConcept from './components/DesignConcept';
import FloorPlan from './components/FloorPlan';
import SmartFacilities from './components/SmartFacilities';
import ParkingAccessibility from './components/ParkingAccessibility';
import RooftopSustainability from './components/RooftopSustainability';
import FeasibilityAnalysis from './components/FeasibilityAnalysis';
import PermitSchedule from './components/PermitSchedule';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <ProjectOverview />
      <LandParcelAnalysis />
      <DesignConcept />
      <FloorPlan />
      <SmartFacilities />
      <ParkingAccessibility />
      <RooftopSustainability />
      <FeasibilityAnalysis />
      <PermitSchedule />
      <Footer />
    </div>
  );
}